module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/integrations/shootProof/modals/shootProof-delete-gallery-modal/shootProof-delete-gallery.modal.scss
// module id = ./web/modern/components/integrations/shootProof/modals/shootProof-delete-gallery-modal/shootProof-delete-gallery.modal.scss
// module chunks = 0